import { useMemo } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { loadOrders } from "../../data/adminData";
import { fmt, bezPvn } from "../../data/store";

export default function AccInvoices() {
  const invoices = useMemo(() => loadOrders().slice(0, 8).map((o, i) => ({
    nr: `INV-2026-${1001 + i}`, date: o.date, total: o.total,
    paid: ["Apmaksāts", "Nosūtīts", "Izpildīts"].includes(o.status),
  })), []);
  return (
    <div data-testid="account-invoices">
      <h2 className="text-xl font-extrabold uppercase mb-4">Rēķini ({invoices.length})</h2>
      <div className="border border-[#E2E2E2]">
        <div className="hidden sm:grid grid-cols-5 gap-2 px-4 py-2.5 text-xs uppercase tracking-wider text-[#6B6B6B] font-bold border-b border-[#E2E2E2]">
          <span>Rēķins</span><span>Datums</span><span>Bez PVN</span><span>Kopā</span><span>Statuss</span>
        </div>
        {invoices.map((inv) => (
          <div key={inv.nr} className="grid grid-cols-2 sm:grid-cols-5 gap-2 items-center px-4 py-3 text-sm border-b border-[#F5F5F5]" data-testid={`acc-invoice-${inv.nr}`}>
            <span className="font-bold">{inv.nr}</span>
            <span className="text-[#6B6B6B]">{new Date(inv.date).toLocaleDateString("lv-LV")}</span>
            <span className="hidden sm:block">{fmt(bezPvn(inv.total))}</span>
            <span className="font-bold">{fmt(inv.total)}</span>
            <span className="flex items-center justify-between gap-2">
              <span className={`text-[11px] font-bold px-2 py-0.5 ${inv.paid ? "bg-[#1E9E45] text-white" : "bg-[#E5A000] text-white"}`}>{inv.paid ? "Apmaksāts" : "Gaida apmaksu"}</span>
              <button onClick={() => toast.success(`${inv.nr} PDF lejupielādēts (DEMO)`)} data-testid={`acc-invoice-pdf-${inv.nr}`}
                className="flex items-center gap-1 text-xs font-bold hover:text-[#D0121A]"><Download size={13} /> PDF</button>
            </span>
          </div>
        ))}
      </div>
      <p className="text-xs text-[#6B6B6B] mt-3">Neapmaksātie rēķini jāapmaksā 14 dienu laikā saskaņā ar līgumu. Kavējuma gadījumā sazinieties ar menedžeri.</p>
    </div>
  );
}
